<template>
  <div class="chart-dialog">
    <el-dialog :title="title" :visible.sync="chartDialogShow" width="50%" :before-close="dialogClose">
      <div style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
        " v-if="chartType == 'classDimension'">
        <span>科目：</span>
        <el-select v-model="course" placeholder="请选择" @change="selectCourseConfirm">
          <el-option v-for="(item, index) in courseList" :key="index" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <!-- 柱状图 -->
      <div id="myChart" ref="chart" style="height: 400px; width: 100%; margin: 0 auto"></div>
      <div style="text-align: center" v-if="chartType != 'classExam'">
        <!-- 班级成绩对比 -->
        <el-button v-if="chartType == 'classComparison'" type="success" round @click="derive"
          v-hasPermi="'sc:classscorecomparison:export'">导出excel</el-button>
        <!-- 校外成绩对比 -->
        <el-button v-if="chartType == 'externalPerformanceComparison'" type="success" round @click="derive"
          v-hasPermi="'sc:extramuralgrade:export'">导出excel</el-button>
        <!-- 班级维度对比 -->
        <el-button v-if="chartType == 'classDimension'" type="success" round @click="derive"
          v-hasPermi="'sc:classdimension:export'">导出excel</el-button>
        <el-button type="primary" round @click="changeChart">切换视图</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { baseURL } from "@/api/request"; // 服务器地址
export default {
  props: [
    "chartType",
    "chartDialogShow",
    "scoreClassContrastData",
    "tableData",
    "selectCourseDialogShow",
    "courseFullList",
    "courseList",
    "classSelectList",
    "examInfo",
  ],
  data() {
    return {
      myChart: null,
      hasShownWarning: false, // 班级维度对比选择科目没有数据时只提示一次的状态
      course: "", // 班级维度对比选择的科目
      classDimensionInit: false, // 班级维度是否初始化过
      isRadar: true
    };
  },
  computed: {
    title() {
      return this.chartType == "classComparison"
        ? "班级成绩对比"
        : this.chartType == "externalPerformanceComparison"
          ? "校外成绩对比"
          : this.chartType == "classExam"
            ? "班级考试信息"
            : "班级维度对比";
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.chartType == "classExam") {
        this.initChart();
      } else {
        // 初始化图
        this.initChart(JSON.parse(JSON.stringify(this.scoreClassContrastData)));
      }
    }, 200);
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    // 导出
    derive() {
      let action;
      if (this.chartType == "classComparison") {
        action = `${baseURL}${this.$url.scoreClassContrastExcelPC}?examInfoId=${this.examInfo[0].id}&classIds=${this.classSelectList}`;
      } else if (this.chartType == "externalPerformanceComparison") {
        action = `${baseURL}${this.$url.scoreClassExtramuralContrastExcelPC}?examInfoId=${this.examInfo[0].id}&classIds=${this.classSelectList}&outsideSchoolSign=${this.scoreClassContrastData[0].outsideSchoolSign}`;
      } else if ((this.chartType = "classDimension")) {
        action = `${baseURL}${this.$url.classExamInLatitudeContrastExcelPC}?examInfoId=${this.examInfo[0].id}&classIds=${this.classSelectList}`;
      }

      window.open(action);
    },
    // 班级维度-切换科目
    selectCourseConfirm(e) {
      this.course = e;
      let data = JSON.parse(JSON.stringify(this.scoreClassContrastData));
      data.forEach((item) => {
        item.examInfoLatitudePCDTOS = item.examInfoLatitudePCDTOS.filter(
          (cItem) => cItem.courseName == e
        );
      });

      // console.log(data);
      if (!this.isRadar) {
        this.barGraphInit(data);
      } else {
        this.initChart(data);
      }
    },
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:chartDialogShow", false);
      this.clearChart();
    },
    // 切换视图
    changeChart() {
      // console.log(this.scoreClassContrastData);
      this.clearChart();

      let data = JSON.parse(JSON.stringify(this.scoreClassContrastData));
      // 班级维度处理数据
      if (this.chartType == "classDimension") {
        data.forEach((item) => {
          item.examInfoLatitudePCDTOS = item.examInfoLatitudePCDTOS.filter(
            (cItem) => cItem.courseName == this.course
          );
        });
      }

      // 根据是否为雷达图初始化图，否则初始化柱状图，并根据是否班级维度对比弹窗传递不同数据
      let chartData =
        this.chartType == "classDimension"
          ? data
          : this.scoreClassContrastData;

      if (this.isRadar) {
        // 雷达
        this.barGraphInit(chartData);
      } else {
        // 柱状图
        this.drawRadarChart(chartData);
      }
      this.isRadar = !this.isRadar;
    },
    initChart(data) {
      // 如果是第一次初始化的班级维度对比图
      if (!this.classDimensionInit && this.chartType == "classDimension") {
        // 默认选中第一个科目以及对应的数据
        this.course = this.courseList[0];
        data.forEach((item) => {
          item.examInfoLatitudePCDTOS = item.examInfoLatitudePCDTOS.filter(
            (cItem) => cItem.courseName == this.course
          );
        });
        // 修改状态，后面不再执行
        this.classDimensionInit = true;
      }

      if (this.chartType == "classExam") {
        // 班级考试查看视图时的柱状图初始化
        this.classExamInit();
      } else {
        // 班级对比、校外对比、维度对比的雷达图初始化
        // 如果为维度对比时使用传过来的data数据，否则直接使用完整数据scoreClassContrastData
        let chartData =
          this.chartType == "classDimension"
            ? data
            : this.scoreClassContrastData;
        this.noClassExamInit(chartData);
      }
    },
    // 班级考试点击查看视图弹窗-柱状图
    classExamInit() {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let dimensionsList = ["product"];
      let sourceList = [];
      let seriesList = [];

      // 遍历tableData数组中的每个元素
      this.tableData.forEach((item) => {
        // 将课程名称添加到dimensionsList数组中
        dimensionsList.push(item.courseName);
        // 为每个数据条目添加一个柱状图选择项
        seriesList.push({
          type: "bar",
        });

        // 遍历descList数组中的每个元素
        item.descList.forEach((cItem) => {
          // 查找sourceList数组中是否存在与当前元素相同的产品
          const existingItem = sourceList.find(
            (sItem) => sItem.product === cItem.desc
          );

          // 如果不存在相同的产品，则将当前产品及其对应的课程名称和描述率添加到sourceList数组中
          if (!existingItem) {
            sourceList.push({
              product: cItem.desc,
              [item.courseName]: cItem.descRate,
            });
          } else {
            // 如果存在相同的产品，则更新该产品对应课程名称的描述率
            existingItem[item.courseName] = cItem.descRate;
          }
        });
      });

      // console.log(dimensionsList, sourceList);

      const option = {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: dimensionsList,
          source: sourceList,
        },
        xAxis: { type: "category" },
        yAxis: {},
        series: seriesList,
      };
      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    // 柱状图初始化
    barGraphInit(data) {
      // console.log(data);
      this.myChart = echarts.init(document.getElementById("myChart"));
      // 如果是校外成绩对比执行(处理校外成绩的数据，将校外成绩添加到data中)
      if (this.chartType === "externalPerformanceComparison") {
        const { outsideSchoolSign, avgScoreList } = data[0];

        // 检查 data 数组中是否已存在相同的 className
        const existingClass = data.find(item => item.className === outsideSchoolSign);

        if (!existingClass) {
          // 如果不存在，则添加新的对象
          data.push({
            className: outsideSchoolSign,
            avgScoreList: avgScoreList.map(item => ({ ...item, classAvgScore: item.externalAvgScore })),
          });
        }
      }

      // 初始化变量
      let categories = [];
      let seriesData = [];
      let legendData = [];


      // 遍历数据
      data.forEach((v, i) => {
        if (this.chartType == "externalPerformanceComparison") {
          // 如果图表类型是外部表现对比
          // 将班级名称添加到图例数据数组
          legendData.push(v.className);
          // 遍历平均分列表
          v.avgScoreList.forEach((item, index) => {
            // 构建对象 o，包括文本和最大值
            if (!categories.includes(item.courseName)) {
              categories.push(item.courseName);
            }
          });
        } else if (this.chartType == "classDimension") {
          // 如果图表类型是班级维度对比
          // 将班级名称添加到图例数据数组
          legendData.push(v.className);
          // 遍历课程统计列表
          v.examInfoLatitudePCDTOS.forEach((item, index) => {
            // 如果描述列表长度大于 0
            if (item.descList.length > 0) {
              // 遍历描述列表
              item.descList.forEach((aItem) => {
                if (!categories.includes(aItem.desc)) {
                  categories.push(aItem.desc);
                }
              });
            } else if (!this.hasShownWarning && item.descList.length == 0) {
              // 如果未显示警告且描述列表长度为 0，则显示警告信息
              this.$message.warning("该科目暂无维度信息");
              this.hasShownWarning = true;
            }
          });
        } else {
          // 如果图表类型不是外部表现对比或班级维度对比
          // 将班级名称添加到图例数据数组
          legendData.push(v.className);
          // 遍历平均分列表
          v.avgScoreList.forEach((item, index) => {
            if (!categories.includes(item.courseName)) {
              categories.push(item.courseName);
            }
          });
        }
      });

      if (this.chartType == "externalPerformanceComparison") {
        data.forEach((v, i) => {
          let seriesItem = {
            name: v.className,
            type: 'bar',
            data: v.avgScoreList.map(item => item.classAvgScore),
          };
          seriesData.push(seriesItem);
        });
      } else if (this.chartType == "classDimension") {
        data.forEach((v, i) => {
          let seriesItem = {
            name: v.className,
            type: 'bar',
            data: v.examInfoLatitudePCDTOS.reduce((acc, item) => {
              acc.push(...item.descList.map(descItem => descItem.descRate));
              return acc;
            }, []),
          };
          seriesData.push(seriesItem);
        });
      } else {
        data.forEach((v, i) => {
          let seriesItem = {
            name: v.className,
            type: 'bar',
            data: v.avgScoreList.map(item => item.avgscore),
          };
          seriesData.push(seriesItem);
        });
      }

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: legendData,
        },
        xAxis: {
          type: 'category',
          data: categories,
        },
        yAxis: {
          type: 'value',
        },
        series: seriesData,
      };

      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      // 随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    // 雷达图初始化
    drawRadarChart(data) {
      this.myChart = echarts.init(document.getElementById("myChart"));

      let o;
      let arr1 = [];
      let arr2 = [];
      let legendData = [];

      data.forEach((v, i) => {
        if (this.chartType == "externalPerformanceComparison") {
          legendData.push(v.className);
          arr2.push({ value: v.avgScoreList, name: v.className });

          v.avgScoreList.forEach((item, index) => {
            o = {
              text: item.courseName + item.fullScore,
              max: item.fullScore,
            };
            if (!arr1.find((aItem) => aItem.text === o.text)) {
              arr1.push(o);
            }
          });
        } else if (this.chartType == "classDimension") {
          legendData.push(v.className);
          v.examInfoLatitudePCDTOS.forEach((item, index) => {
            if (item.descList.length > 0) {
              arr2.push({ value: item.descList, name: v.className });
              item.descList.forEach((aItem) => {
                o = {
                  text: aItem.desc,
                  max: 100,
                };
                if (!arr1.find((bItem) => bItem.text === o.text)) {
                  arr1.push(o);
                }
              });
            } else if (!this.hasShownWarning && item.descList.length == 0) {
              this.$message.warning("该科目暂无维度信息");
              this.hasShownWarning = true;
            }
          });
        } else {
          legendData.push(v.className);
          arr2.push({ value: v.avgScoreList, name: v.className });
        }
      });

      if (this.chartType == "externalPerformanceComparison") {
        arr2.forEach((item) => {
          item.value = item.value.map((vItem) => vItem.classAvgScore);
        });
      } else if (this.chartType == "classDimension") {
        arr2.forEach((item) => {
          item.value = item.value.map((vItem) => vItem.descRate);
        });
      } else {
        data[0].avgScoreList.forEach((item) => {
          o = {
            text: item.courseName + item.fullScore,
            max: item.fullScore,
          };
          if (!arr1.find((aItem) => aItem.text === o.text)) {
            arr1.push(o);
          }
        });
        arr2.forEach((item) => {
          item.value = item.value.map((vItem) => vItem.avgscore);
        });
      }

      const option = {
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: legendData,
        },
        radar: {
          indicator: arr1,
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: arr2,
          },
        ],
      };

      this.myChart.setOption(option);

      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
    // 班级考试各种对比弹窗-雷达图
    noClassExamInit(data) {
      // console.log(data);
      this.myChart = echarts.init(document.getElementById("myChart"));
      // 如果是校外成绩对比执行(处理校外成绩的数据，将校外成绩添加到data中)
      if (this.chartType == "externalPerformanceComparison") {
        let copyData = JSON.parse(JSON.stringify(data));
        data.push({
          className: copyData[0].outsideSchoolSign,
          avgScoreList: copyData[0].avgScoreList.map((item) => {
            item.classAvgScore = item.externalAvgScore;
            return item;
          }),
        });
      }

      // 初始化变量
      let o;
      let arr1 = [];
      let arr2 = [];
      let legendData = [];

      // 遍历数据
      data.forEach((v, i) => {
        if (this.chartType == "externalPerformanceComparison") {
          // 如果图表类型是外部表现对比
          // 将班级名称添加到图例数据数组
          legendData.push(v.className);
          // 将平均分列表和班级名称添加到 arr2 数组
          arr2.push({ value: v.avgScoreList, name: v.className });
          // 将校外标识和平均分列表添加到 arr2 数组
          // legendData.push(v.outsideSchoolSign);
          // arr2.push({ value: v.avgScoreList, name: v.outsideSchoolSign });

          // 遍历平均分列表
          v.avgScoreList.forEach((item, index) => {
            // console.log(item);
            // 构建对象 o，包括文本和最大值
            o = {
              text: item.courseName + item.fullScore,
              max: item.fullScore,
            };
            // 如果 arr1 数组中不存在与 o 相同文本的对象，则将 o 添加到 arr1 数组
            if (!arr1.find((aItem) => aItem.text === o.text)) {
              arr1.push(o);
            }
          });
        } else if (this.chartType == "classDimension") {
          // 如果图表类型是班级维度对比
          // 将班级名称添加到图例数据数组
          legendData.push(v.className);
          // 遍历课程统计列表
          v.examInfoLatitudePCDTOS.forEach((item, index) => {
            // 如果描述列表长度大于 0
            if (item.descList.length > 0) {
              // 将描述列表和班级名称添加到 arr2 数组
              arr2.push({ value: item.descList, name: v.className });
              // 遍历描述列表
              item.descList.forEach((aItem) => {
                // 构建对象 o，包括文本和最大值
                o = {
                  text: aItem.desc,
                  max: 100,
                };
                // 如果 arr1 数组中不存在与 o 相同文本的对象，则将 o 添加到 arr1 数组
                if (!arr1.find((bItem) => bItem.text === o.text)) {
                  arr1.push(o);
                }
              });
            } else if (!this.hasShownWarning && item.descList.length == 0) {
              // 如果未显示警告且描述列表长度为 0，则显示警告信息
              this.$message.warning("该科目暂无维度信息");
              this.hasShownWarning = true;
            }
          });
        } else {
          // 如果图表类型不是外部表现对比或班级维度对比
          // 将班级名称添加到图例数据数组
          legendData.push(v.className);
          // 将平均分列表和班级名称添加到 arr2 数组
          arr2.push({ value: v.avgScoreList, name: v.className });
        }
      });

      if (this.chartType == "externalPerformanceComparison") {
        // console.log("arr2==>", arr2, legendData);
        // 单个班级与校外成绩对比
        // arr2[0].value = arr2[0].value.map((vItem) => vItem.classAvgScore);
        // arr2[arr2.length + 1].value = arr2[1].value.map((vItem) => vItem.externalAvgScore);
        arr2.forEach((item) => {
          item.value = item.value.map((vItem) => vItem.classAvgScore);
        });
      } else if (this.chartType == "classDimension") {
        // 班级维度对比
        arr2.forEach((item) => {
          item.value = item.value.map((vItem) => vItem.descRate);
        });
      } else {
        //  班级考试平均分对比
        // 分制中的科目添加
        data[0].avgScoreList.forEach((item) => {
          o = {
            text: item.courseName + item.fullScore,
            max: item.fullScore,
          };
          if (!arr1.find((aItem) => aItem.text === o.text)) {
            arr1.push(o);
          }
        });
        // 赋值平均分
        arr2.forEach((item) => {
          item.value = item.value.map((vItem) => vItem.avgscore);
        });
      }

      // console.log(data, legendData, arr1, arr2);

      const option = {
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "#fff", // 悬浮框背景色
          borderColor: "#000", // 悬浮框边框颜色
          borderWidth: 1, // 悬浮框边框宽度
          textStyle: {
            // 悬浮框文字样式
            color: "#000",
            fontSize: 12,
          },
        },
        legend: {
          data: legendData,
        },
        radar: {
          indicator: arr1,
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: arr2,
          },
        ],
      };

      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementChartDialog.scss";
</style>